import MusicPlayList from './components/MusicPlayList'

import './App.css'

// Replace your code here

const App = () => <MusicPlayList />

export default App
